(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const accordionTriggers = document.querySelectorAll('.faq__accordion-trigger');

    accordionTriggers.forEach(trigger => {
      trigger.addEventListener('click', function() {
        const parent = this.parentElement;
        const content = this.nextElementSibling;
        const isOpen = parent.classList.contains('is-open');

        // Optional: Close all other open accordions
        document.querySelectorAll('.faq__accordion-item.is-open').forEach(item => {
          if (item !== parent) {
            item.classList.remove('is-open');
            item.querySelector('.faq__accordion-trigger').setAttribute('aria-expanded', 'false');
            item.querySelector('.faq__accordion-content').style.maxHeight = null;
          }
        });

        // Toggle the clicked accordion
        if (isOpen) {
          parent.classList.remove('is-open');
          this.setAttribute('aria-expanded', 'false');
          content.style.maxHeight = null;
        } else {
          parent.classList.add('is-open');
          this.setAttribute('aria-expanded', 'true');
          content.style.maxHeight = content.scrollHeight + "px";
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const footerFormElement = document.querySelector('.footer__newsletter-form');
    const footerSubmitBtn = document.getElementById('FooterSubscribeSubmitBtn'); // UPDATED
    const footerbtnText = footerSubmitBtn ? footerSubmitBtn.querySelector('.footer__btn-text') : null;
    const footerbtnLoading = footerSubmitBtn ? footerSubmitBtn.querySelector('.footer__btn-loading') : null;
    const footerEmailInput = document.getElementById('FooterNewsletterEmail'); // UPDATED

   function setBtnLoading() {
      if (footerbtnText && footerbtnLoading) {
        footerbtnText.style.display = 'none';
        footerbtnLoading.style.display = 'inline-flex';
      }
    }

    function resetBtnState() {
      if (footerbtnText && footerbtnLoading) {
        footerbtnText.textContent = 'Join now';
        footerbtnText.style.display = 'inline-block';
        footerbtnLoading.style.display = 'none';
      }
    }

    if (footerFormElement) {
      footerFormElement.addEventListener('submit', function() {
        if (footerFormElement.checkValidity()) {
          setBtnLoading();
          sessionStorage.setItem('newsletter_source', 'footer');
        }
      });
    }

    if (footerEmailInput) {
      footerEmailInput.addEventListener('input', resetBtnState);
    }

    // Check for success/error on load and alter button text
    const footerFormSuccess = document.querySelector('.footer__newsletter-success');
    const footerFormError = document.querySelector('.footer__newsletter-error');
    const submittedSource = sessionStorage.getItem('newsletter_source'); 
    
    // Only show the footer success text if the memory says "footer"
    if ((footerFormSuccess || footerFormError) && submittedSource === 'footer') {
      if (footerFormSuccess && footerbtnText) footerbtnText.textContent = 'THANK YOU';
      if (footerFormError && footerbtnText) footerbtnText.textContent = 'SOMETHING WENT WRONG';
      sessionStorage.removeItem('newsletter_source');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const menuTrigger = document.getElementById('MenuTrigger');
    const drawerMenu = document.getElementById('DrawerMenu');
    const drawerOverlay = document.getElementById('DrawerOverlay');
    const drawerClose = document.getElementById('DrawerClose');
    const popupTrigger = document.getElementById('PopupTrigger');
    const popupClose = document.getElementById('PopupClose'); 
    
    // FIX: Variables properly mapped and cased to avoid ReferenceErrors
    const newsletterPopupOverlay = document.getElementById('NewsletterPopupOverlay'); 
    const newsletterPopup = document.getElementById('NewsletterPopup'); 

    const formElement = document.querySelector('.header__newsletter-form');
    const submitBtn = document.getElementById('SubscribeSubmitBtn');
    const btnText = submitBtn ? submitBtn.querySelector('.btn-text') : null;
    const btnLoading = submitBtn ? submitBtn.querySelector('.btn-loading') : null;
    const emailInput = document.getElementById('NewsletterEmail');

    const header = document.querySelector('header');
    const signUpBanner = document.querySelector('.header__sign-up');

    if (signUpBanner) {
      window.addEventListener('scroll', () => {
        if (window.scrollY > 100) {
          signUpBanner.classList.add('scrolled-past-100');
        } else {
          signUpBanner.classList.remove('scrolled-past-100');
        }
      });
    }

    function openDrawer() {
      drawerMenu.classList.add('is-active');
      drawerOverlay.classList.add('is-active');
      document.body.style.overflow = 'hidden'; 
    }

    function closeDrawer() {
      drawerMenu.classList.remove('is-active');
      drawerOverlay.classList.remove('is-active');
      document.body.style.overflow = ''; 
    }

   function setBtnLoading() {
      if (btnText && btnLoading) {
        btnText.style.display = 'none';
        btnLoading.style.display = 'inline-flex';
      }
    }

    function resetBtnState() {
      if (btnText && btnLoading && submitBtn) {
        btnText.textContent = submitBtn.getAttribute('data-default-text') || 'Join now';
        btnText.style.display = 'inline-block';
        btnLoading.style.display = 'none';
      }
    }

    if (formElement) {
      formElement.addEventListener('submit', function() {
        if (formElement.checkValidity()) {
          setBtnLoading();
          sessionStorage.setItem('newsletter_source', 'header');
        }
      });
    }

    if (emailInput) {
      emailInput.addEventListener('input', resetBtnState);
    }

    function openPopup() {
      newsletterPopupOverlay.classList.add('is-active');
      newsletterPopup.classList.add('is-active');
      document.body.style.overflow = 'hidden'; 
      setTimeout(() => {
        if (emailInput) {
          emailInput.focus();
        }
      }, 100);
    }

    function closePopup() {
      newsletterPopupOverlay.classList.remove('is-active');
      newsletterPopup.classList.remove('is-active');
      document.body.style.overflow = ''; 
      resetBtnState();
    }

    const formSuccess = document.querySelector('.header__newsletter-success');
    const formError = document.querySelector('.header__newsletter-error');
    const submittedSource = sessionStorage.getItem('newsletter_source'); 
    
    if ((formSuccess || formError) && submittedSource === 'header') {
      const successMsg = newsletterPopup.getAttribute('data-success-text') || 'THANK YOU';
      const errorMsg = newsletterPopup.getAttribute('data-error-text') || 'SOMETHING WENT WRONG';

      if (formSuccess && btnText) btnText.textContent = successMsg;
      if (formError && btnText) btnText.textContent = errorMsg;
      
      openPopup();
      sessionStorage.removeItem('newsletter_source');
    }

    // Event Listeners (FIX: the overlay listener is now correctly lowercased)
    if(menuTrigger) menuTrigger.addEventListener('click', openDrawer);
    if(drawerClose) drawerClose.addEventListener('click', closeDrawer);
    if(drawerOverlay) drawerOverlay.addEventListener('click', closeDrawer); 
    if(popupTrigger) popupTrigger.addEventListener('click', openPopup);
    if(popupClose) popupClose.addEventListener('click', closePopup);
    if(newsletterPopupOverlay) newsletterPopupOverlay.addEventListener('click', closePopup); 
    
    const triggers = document.querySelectorAll('.color-change-trigger');

    if (header && triggers.length > 0) {
      
      function updateHeaderColors(targetDiv) {
        const headerSvgColor = targetDiv.dataset.headerSvgColor || '#E83500';
        const headerButtonColor = targetDiv.dataset.headerButtonColor || '#FDFCED';
        const headerBackgroundColor = targetDiv.dataset.headerBackgroundColor || '#FDFCED';
        const headerBorderColor = targetDiv.dataset.headerBorderColor || '#000000';
        header.style.setProperty('--header-button-color', headerButtonColor);
        header.style.setProperty('--header-svg', headerSvgColor);
        header.style.setProperty('--header-background-color', headerBackgroundColor);
        header.style.setProperty('--header-border-color', headerBorderColor);
      }

      const observerOptions = {
        root: null,
        rootMargin: "0px 0px -85% 0px",
        threshold: 0 
      };

      const headerObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
             updateHeaderColors(entry.target);
          }
        });
      }, observerOptions);

      triggers.forEach(trigger => {
        headerObserver.observe(trigger);
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
